import styled from 'styled-components';
const scrollBarHeight = '17px';
export const Container = styled.div `
  overflow: hidden;
  margin-top: -${scrollBarHeight};
`;
export const Tray = styled.div `
  position: relative;
  overflow-x: auto;
  padding-bottom: ${scrollBarHeight};
  top: ${scrollBarHeight};
`;
//# sourceMappingURL=styles.js.map